import React from 'react';
import PropTypes from 'prop-types';
import { useTabsNavigationStore } from '../../../../stores';
import { GAME_TYPES } from '../../model/navModel';
import DemocracyGame from './democracy/DemocracyGame';
import KillerGame from './killer/KillerGame';
import BetsGame from './bets/BetsGame';
import LegendsGame from './legends/LegendsGame';
import FairGame from './fair/FairGame';
import SpiteGame from './spite/SpiteGame';
import DozorGame from './dozor/DozorGame';
import TeamTaskGame from './teamtask/TeamTaskGame';

// Диспетчер раздела «Игры»: каждая игра — свой каркас нового layout.
export default function GamesContent({ shift }) {
    const selectedGame = useTabsNavigationStore(state => state.selectedGame);

    if (selectedGame === GAME_TYPES.DEMOCRACY) {
        return <DemocracyGame shift={shift} />;
    }
    if (selectedGame === GAME_TYPES.KILLER) {
        return <KillerGame shift={shift} />;
    }
    if (selectedGame === GAME_TYPES.BET) {
        return <BetsGame shift={shift} />;
    }
    if (selectedGame === GAME_TYPES.LEGEND) {
        return <LegendsGame shift={shift} />;
    }
    if (selectedGame === GAME_TYPES.FAIR) {
        return <FairGame shift={shift} />;
    }
    if (selectedGame === GAME_TYPES.NEIGHBOR) {
        return <SpiteGame shift={shift} />;
    }
    if (selectedGame === GAME_TYPES.DOZOR) {
        return <DozorGame shift={shift} />;
    }
    if (selectedGame === GAME_TYPES.TEAM_TASK) {
        return <TeamTaskGame shift={shift} />;
    }

    return <div className="vp-empty">Выберите игру</div>;
}

GamesContent.propTypes = {
    shift: PropTypes.shape({ id: PropTypes.number.isRequired }).isRequired
};
